import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";
const { persistAtom } = recoilPersist();

export const isBlackUIViewState = atom({
  key: "isBlackUIViewState",
  default: false,
  effects_UNSTABLE: [persistAtom],
});
